import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { diagnosticQuestions } from '../../data/onboardingData';

const { FiArrowRight, FiCheck } = FiIcons;

function DiagnosticStep({
  questionIndex,
  answers,
  onAnswer,
  onNext
}) {
  const question = diagnosticQuestions[questionIndex];
  const selectedAnswer = answers[question.id];
  const isLast = questionIndex === diagnosticQuestions.length - 1;

  return (
    <div>
      <span className="eyebrow">For Emmanuel</span>

      <div className="mt-3 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-['Manrope'] text-3xl font-bold tracking-[-0.04em] text-[#24302d]">
            A quick learning check-in
          </h1>
          <p className="mt-3 text-sm text-[#6c7773]">
            Choose the answer that feels best. This is not pass or fail.
          </p>
        </div>

        <span className="rounded-lg bg-[#f2f2ee] px-3 py-2 text-xs font-semibold text-[#6c7773]">
          Question {questionIndex + 1} of {diagnosticQuestions.length}
        </span>
      </div>

      <div className="mt-7 h-1.5 overflow-hidden rounded-full bg-[#eceeea]">
        <span
          className="block h-full rounded-full bg-[#7c3aed] transition-all"
          style={{
            width: `${((questionIndex + 1) / diagnosticQuestions.length) * 100}%`
          }}
        />
      </div>

      <div className="mt-8">
        <span className="text-xs font-bold uppercase tracking-[0.1em] text-[#4f776d]">
          {question.subject}
        </span>
        <h2 className="mt-3 text-xl font-semibold leading-8 text-[#24302d]">
          {question.question}
        </h2>

        <div className="mt-5 grid gap-3">
          {question.options.map((option) => {
            const selected = option === selectedAnswer;

            return (
              <button
                className={`flex items-center justify-between rounded-xl border px-4 py-4 text-left text-sm transition ${
                  selected
                    ? 'border-[#7c3aed] bg-[#f3e8ff] text-[#24302d]'
                    : 'border-[#e3e4de] bg-white text-[#59635f] hover:border-[#a78bfa]'
                }`}
                key={option}
                onClick={() => onAnswer(question.id, option)}
                type="button"
              >
                {option}
                {selected && (
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#7c3aed] text-white">
                    <SafeIcon icon={FiCheck} />
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-8 flex justify-end">
        <button
          className="flex items-center gap-2 rounded-xl bg-[#7c3aed] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#5b21b6] disabled:cursor-not-allowed disabled:opacity-50"
          disabled={!selectedAnswer}
          onClick={onNext}
          type="button"
        >
          {isLast ? 'See placement' : 'Next question'}
          <SafeIcon icon={FiArrowRight} />
        </button>
      </div>
    </div>
  );
}

export default DiagnosticStep;